var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jzliu-bi-engine-mobile-preview" }, [
    _c("div", { staticClass: "jzliu-bi-engine-mobile-preview-warp" }, [
      _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }